import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";

const TagPoints = ({ PointsValue }) => {
  const pointStatus =
    PointsValue.substring(0, 1) === "+"
      ? 1
      : PointsValue.substring(0, 1) === "-"
      ? 2
      : 3;
  const points = PointsValue.substring(1);
  let TagRender;
  if (pointStatus === 1) {
    TagRender = <Tag color="green">+ {points}</Tag>;
  } else if (pointStatus === 2) {
    TagRender = <Tag color="magenta">- {points}</Tag>;
  } else {
    TagRender = <Tag>{points}</Tag>;
  }
  return <>{TagRender}</>;
};

TagPoints.propTypes = {
  PointsValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default TagPoints;
